import { Component, ChangeDetectionStrategy, Input } from '@angular/core'
import { GaugeComponentViewbox } from '../gauge-component-viewbox'
import { CommonModule } from '@angular/common'

/**
 * @internal
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'g[gpeiGaugeNeedle]',
  templateUrl: './gauge-needle.component.html',
  styleUrls: [ './gauge-needle.component.sass' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class GaugeNeedleComponent {

  /**
   * The starting width of the needle
   */
  @Input() startWidth: number

  /**
   * The ending width of the needle
   */
  @Input() endWidth: number

  /**
   * The length of the needle
   */
  @Input() length: number

  /**
   * The angle that the needle will be rotated
   */
  @Input() angle: number

  /**
   * An SVG string path of the drawn needle
   */
  get needlePath(): string {
    return `
      M ${ this.center - this.startWidth / 2 }  ${ this.center }
      L ${ this.center - this.endWidth / 2 }    ${ this.center - this.length }
      L ${ this.center + this.endWidth / 2 }    ${ this.center - this.length }
      L ${ this.center + this.startWidth / 2 }  ${ this.center }
      Z
      `
  }

  /**
   * The center of the viewbox
   */
  get center(): number {
    return GaugeComponentViewbox.CENTER
  }

  /**
   * The radius of the rounded needle start. Calculated based on the starting
   * width of the needle.
   */
  get circleRadius(): number {
    return this.startWidth / 2
  }

}
